import React from 'react';
import { Dropdown, Button } from "tea-component";
import classNames from "classnames";
import { useIntl } from "umi";
import CustomJustify from "@/pages/datalab/components/CustomJustify";
import GridBox from "@/pages/datalab/components/GridBox";
import './index.scss';

const SWATCH_COLORS = [
  '#6A6D7E', '#2648A6', '#358561', '#A8831D', '#413CA6', '#307DA6', '#EF8B84', '#BBBDCB', '#A6C9FF', '#92DEB4', '#F5D242', '#AD9EFF', '#8CE2FF', '#FFABAF',
];

export interface ColorSelectorProps {
  value?: string;
  className?: string;
  onChange: (color: string) => void;
  defaultValue?: string;
  [key: string]: any; // For rest props
}
const ColorSelector: React.FC<ColorSelectorProps> = (props) => {
  const { formatMessage } = useIntl();
  const { value, className, onChange, defaultValue='#6A6D7E', ...restProps } = props;
  
  return (<Dropdown
    appearance={'button'}
    placement={'bottom-end'}
    button={(<div
      style={{
        width: "23px",
        height: "23px",
        backgroundColor: value || defaultValue,
        borderRadius: "4px",
        flex: '0 0 auto',
      }}
    />)}
    {...restProps}
    className={'dbl-color-selector-button'}
    boxClassName={'dbl-color-selector-dropdown'}
  >
    <div className={classNames('dbl-color-selector', className)}>
      <CustomJustify className={'dbl-color-selector-header'}
        left={formatMessage({id: 'dbl_common_default'})}
        right={<Button type={'link'} onClick={() => onChange(defaultValue)}>{formatMessage({id: 'dbl_chart_advanced_reference_line_restore'})}</Button>}
      />
      
      <GridBox
        grid={{row: 2, column: 7}}
        gap={16}
        className={'dbl-color-selector-swatch-wrap'}
      >
        {
          SWATCH_COLORS.map(color => (<GridBox.Item
            key={color}
            className={'dbl-color-selector-swatch'}
            onClick={() => onChange(color)}
          >
            <svg width="20" height="20" viewBox="0 0 20 20">
              <rect x="0" y="0" width="20" height="20" rx="2" fill={color}/>
              {
                value === color ? (<path
                  d="M5 10 L8 13 L15 6"
                  stroke="white"
                  strokeWidth="2"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />) : ''
              }
            </svg>
          </GridBox.Item>))
        }
      </GridBox>
    </div>
  </Dropdown>);
};


export default ColorSelector;